// extracted by mini-css-extract-plugin
module.exports = {"options":"oddFormatSelect__options___1aHHb","option":"oddFormatSelect__option___U3JDL","is-selected":"oddFormatSelect__is-selected___3QnH9"};